import Vue from "vue";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap-vue/dist/bootstrap-vue-icons.min.css";

// variable overrides [https://bootstrap-vue.org/docs/reference/theming]
// import "@/assets/give-proudly-style.scss";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
